import { render, staticRenderFns } from "./EventManagerSetting.vue?vue&type=template&id=876837de"
import script from "./EventManagerSetting.vue?vue&type=script&lang=js"
export * from "./EventManagerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports